export const isInteger = (n) => !isNaN(parseFloat(n)) && isFinite(n);
